<template>
  <label class="group relative block w-full max-w-full text-slate">
    <span
      v-if="label"
      class="absolute -top-1.5 left-3.5 z-10 whitespace-nowrap bg-white px-1 text-md group-hover:text-gray"
    >
      {{ label }}
    </span>

    <input
      ref="input"
      v-model="valueLocal"
      :placeholder="placeholder"
      :type="type"
      :class="[
        { '!border-red-lighten1': error },
        { '!border-gray-lighten1 !text-slate-lighten4': disabled },
        rounded,
      ]"
      class="h-16 w-full border-gray-lighten1 px-6 text-md transition placeholder:text-slate-lighten4 focus:border-slate-lighten4 focus:outline-0 focus:outline-offset-0 focus:ring-0 group-hover:border-gray"
    />

    <span v-if="error" class="block py-1 text-red-lighten1">
      {{ error }}
    </span>
  </label>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

interface Props {
  modelValue?: string | number | null;
  modelModifiers?: Record<string, boolean>;
  placeholder?: string;
  label?: string | null;
  type?: string;
  error?: string | null;
  disabled?: boolean;
  rounded?: string;
}
interface Emits {
  (e: 'update:modelValue', data: Props['modelValue']): void;
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: null,
  modelModifiers: () => ({}),
  placeholder: undefined,
  label: null,
  type: 'text',
  error: null,
  disabled: false,
  rounded: 'rounded-xl',
});

const emit = defineEmits<Emits>();

const valueLocal = computed({
  get() {
    return props.modelValue;
  },
  set(newValue) {
    emit('update:modelValue', newValue);
  },
});

const input = ref();
</script>
